import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carrentalmumbai() {



    const cardData = {





keyword: "Car Rental Mumbai",

headingDescription: "Shreesha Tours & Travels provides trusted and affordable Car Rental Services in Mumbai for local travel, airport transfers, corporate transportation, railway station pickup and drop, business meetings, family vacations, destination weddings, sightseeing tours, one-way travel, round trips, and outstation journeys across India. We offer a wide range of chauffeur-driven vehicles including Hatchback, Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars to suit every travel requirement and budget. Whether you require a rental car for a few hours, a full day, multiple days, or an extended tour, our well-maintained fleet, professional drivers, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support ensure a smooth and comfortable travel experience. From business executives and corporate teams to families, tourists, and pilgrimage groups, Shreesha Tours & Travels delivers reliable, safe, and hassle-free car rental solutions for every occasion with a strong focus on customer satisfaction and punctual service.",

topPlaces: [
  {
    title: "Mumbai to Lonar",
    description: "Lonar is famous for the unique Lonar Meteor Crater Lake, ancient temples, and geological significance. It is a fascinating destination for nature enthusiasts, photographers, and history lovers."
  },
  {
    title: "Mumbai to Chiplun",
    description: "Chiplun is a beautiful Konkan town known for Parshuram Temple, Vashishti River, lush green valleys, and pleasant surroundings. It is an ideal destination for peaceful family vacations."
  },
  {
    title: "Mumbai to Velas",
    description: "Velas is renowned for its Olive Ridley Turtle Festival, clean beaches, and eco-tourism. It is a perfect getaway for wildlife enthusiasts and families seeking a unique travel experience."
  },
  {
    title: "Mumbai to Sawantwadi",
    description: "Sawantwadi is famous for its royal palace, wooden handicrafts, Moti Talao Lake, and vibrant local culture. It is an excellent destination for heritage lovers and road trips."
  },
  {
    title: "Mumbai to Koynanagar",
    description: "Koynanagar is known for the Koyna Dam, Shivsagar Lake, dense forests, and scenic mountain views. It attracts nature lovers, photographers, and adventure travelers."
  },
  {
    title: "Mumbai to Yercaud",
    description: "Yercaud is a peaceful hill station in Tamil Nadu famous for coffee plantations, Yercaud Lake, Pagoda Point, and cool weather. It is an ideal destination for long-distance family holidays."
  },
  {
    title: "Mumbai to Badami",
    description: "Badami is celebrated for its ancient cave temples, Agastya Lake, sandstone cliffs, and remarkable Chalukyan architecture. It is a popular destination for history and architecture enthusiasts."
  },
  {
    title: "Mumbai to Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site known for its magnificent group of ancient temples showcasing remarkable Indian architecture and cultural heritage."
  },
  {
    title: "Mumbai to Aihole",
    description: "Aihole is regarded as the cradle of Indian temple architecture and features over a hundred historic temples, making it a perfect destination for cultural and educational tours."
  },
  {
    title: "Mumbai to Rameshwaram",
    description: "Rameshwaram is one of the Char Dham pilgrimage destinations, famous for Ramanathaswamy Temple, Pamban Bridge, Dhanushkodi, and its spiritual significance. It is a preferred destination for long-distance religious journeys."
  }
],



"services": [
  {
    "name": "Car Rental Mumbai",
    "description": "Book Car Rental Mumbai for comfortable, reliable, and affordable travel with well-maintained vehicles and professional chauffeurs. Choose from Sedan, SUV, Ertiga, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars for airport transfers, local travel, corporate meetings, sightseeing tours, weddings, family vacations, and outstation journeys. Enjoy flexible one way, round trip, hourly, daily, and customized rental packages with transparent pricing."
  },
  {
    "name": "Mumbai Car Rental Service",
    "description": "Choose Mumbai Car Rental Service for premium transportation with clean AC vehicles, experienced drivers, and excellent customer support. Whether you need a cab for business travel, family outings, airport pickup and drop, holiday tours, or long-distance travel, we provide dependable rental solutions with comfortable vehicles and competitive pricing."
  },
  {
    "name": "Car Hire Mumbai",
    "description": "Hire Car Mumbai for convenient and hassle-free transportation with chauffeur-driven vehicles suitable for personal, corporate, and leisure travel. Our fleet includes economy, premium, luxury, and spacious family vehicles for every travel requirement across Mumbai and beyond."
  },
  {
    "name": "Car Rental with Driver Mumbai",
    "description": "Book Car Rental with Driver Mumbai for stress-free travel with courteous chauffeurs, comfortable vehicles, and flexible travel schedules. Perfect for airport transfers, business meetings, city tours, weddings, family functions, hotel transfers, and interstate journeys with complete safety and convenience."
  },
  {
    "name": "Self Drive Car Rental Mumbai",
    "description": "Choose Self Drive Car Rental Mumbai for flexible travel with well-maintained vehicles available for daily, weekly, and monthly rentals. Enjoy the freedom to explore Mumbai and nearby destinations at your own pace with comfortable and reliable rental cars."
  },
  {
    "name": "Luxury Car Rental Mumbai",
    "description": "Reserve Luxury Car Rental Mumbai for premium travel with elegant vehicles, luxurious interiors, and outstanding comfort. Ideal for weddings, VIP transportation, business executives, celebrity travel, special occasions, airport transfers, and luxury sightseeing experiences."
  },
  {
    "name": "Outstation Car Rental Mumbai",
    "description": "Book Outstation Car Rental Mumbai for comfortable one way and round trip travel across Maharashtra, Goa, Gujarat, Karnataka, Madhya Pradesh, and other destinations. Enjoy experienced drivers, spacious vehicles, affordable fares, and a smooth highway travel experience."
  },
  {
    "name": "Airport Car Rental Mumbai",
    "description": "Choose Airport Car Rental Mumbai for punctual airport pickup and drop services with flight monitoring, luggage assistance, and professional chauffeurs. We provide reliable transportation to and from Mumbai International Airport for business travelers, tourists, families, and corporate clients."
  },
  {
    "name": "Corporate Car Rental Mumbai",
    "description": "Book Corporate Car Rental Mumbai for executive transportation, employee travel, client meetings, airport transfers, conferences, seminars, and corporate events. Our chauffeur-driven vehicles ensure punctual, comfortable, and professional travel for every business requirement."
  },
  {
    "name": "Monthly Car Rental Mumbai",
    "description": "Choose Monthly Car Rental Mumbai for long-term transportation with flexible rental plans, dedicated chauffeurs, and well-maintained vehicles. Ideal for corporate companies, business professionals, consultants, project teams, and extended personal travel requirements."
  },
  {
    "name": "Tourist Car Rental Mumbai",
    "description": "Reserve Tourist Car Rental Mumbai for sightseeing, holiday tours, pilgrimage trips, beach vacations, hill station visits, and weekend getaways. Enjoy comfortable travel with experienced local drivers, spacious vehicles, and customized travel itineraries."
  },
  {
    "name": "Family Car Rental Mumbai",
    "description": "Book Family Car Rental Mumbai for safe and comfortable travel with spacious vehicles suitable for families of all sizes. Perfect for vacations, weddings, temple visits, airport transfers, shopping trips, and outstation holidays with professional chauffeur service."
  },
  {
    "name": "Affordable Car Rental Mumbai",
    "description": "Choose Affordable Car Rental Mumbai for budget-friendly transportation without compromising on comfort, safety, or service quality. Our economical rental packages include clean AC vehicles, experienced drivers, transparent pricing, and flexible booking options for local and outstation travel."
  },
  {
    "name": "Best Car Rental Service Mumbai",
    "description": "Book the Best Car Rental Service Mumbai for premium chauffeur-driven transportation with a wide range of vehicles, courteous drivers, competitive pricing, and exceptional customer support. Whether you need a car for airport transfers, local travel, business meetings, family vacations, weddings, sightseeing, or long-distance outstation journeys, our car rental service provides a reliable, comfortable, and memorable travel experience every time."
  }
],
"tableData": [
  ["Car Rental Mumbai", "Mumbai Car Rental Service"],
  ["Car Hire Mumbai", "Car Rental with Driver Mumbai"],
  ["Self Drive Car Rental Mumbai", "Luxury Car Rental Mumbai"],
  ["Outstation Car Rental Mumbai", "Airport Car Rental Mumbai"],
  ["Corporate Car Rental Mumbai", "Monthly Car Rental Mumbai"],
  ["Tourist Car Rental Mumbai", "Family Car Rental Mumbai"],
  ["Affordable Car Rental Mumbai", "Best Car Rental Service Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Complete Car Rental Solutions in Mumbai",
    WhyChoosedescription: "Whether you're planning a business trip, family vacation, airport transfer, wedding event, city sightseeing, or an outstation tour, Shreesha Travels provides reliable car rental services in Mumbai with a wide range of chauffeur-driven vehicles for every travel requirement."
  },
  {
    WhyChooseheading: "Extensive Fleet for Every Budget & Occasion",
    WhyChoosedescription: "From economical sedans to premium SUVs and spacious group vehicles, our fleet includes Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Travellers, Mini Buses, Luxury Cars, and more."
  },
  {
    WhyChooseheading: "Travel Anywhere Across India",
    WhyChoosedescription: "Our rental cars are available for journeys from Mumbai to Pune, Goa, Lonavala, Mahabaleshwar, Nashik, Shirdi, Surat, Ahmedabad, Bengaluru, Jaipur, Indore, Kolhapur, and hundreds of destinations across the country."
  },
  {
    WhyChooseheading: "Customized Rental Plans for Every Itinerary",
    WhyChoosedescription: "Choose from hourly rentals, full-day packages, one-way cabs, round trips, airport transfers, weekend tours, multi-day road trips, and personalized travel packages designed around your schedule."
  },
  {
    WhyChooseheading: "Reliable Transportation for Personal & Corporate Travel",
    WhyChoosedescription: "Our car rental service caters to business executives, corporate teams, tourists, families, students, wedding guests, event organizers, and travellers looking for dependable transportation."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Every Journey",
    WhyChoosedescription: "Experienced, courteous, and route-aware drivers ensure safe travel, timely pickups, efficient navigation, and a pleasant travel experience throughout Mumbai and beyond."
  },
  {
    WhyChooseheading: "Well-Maintained & Fully Sanitized Vehicles",
    WhyChoosedescription: "Every vehicle undergoes regular maintenance, cleaning, and safety inspections before every trip, ensuring passengers enjoy a comfortable and worry-free journey."
  },
  {
    WhyChooseheading: "Book Your Car Rental with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, easy booking assistance, flexible travel options, and dependable customer support whenever you need a chauffeur-driven car rental service in Mumbai."
  }
]

};

const faqData = [
  {
    question: "What types of cars are available for rental in Mumbai?",
    answer: "We offer Hatchbacks, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, Mini Buses, and other chauffeur-driven vehicles."
  },
  {
    question: "Can I rent a car for both local and outstation travel?",
    answer: "Yes, our vehicles are available for city travel, airport transfers, one-way trips, round trips, sightseeing tours, and long-distance journeys across India."
  },
  {
    question: "Do you provide cars for corporate travel and business meetings?",
    answer: "Yes, companies and professionals can hire our vehicles for executive travel, client visits, conferences, exhibitions, and employee transportation."
  },
  {
    question: "Can I book a rental car for weddings and special occasions?",
    answer: "Yes, we provide transportation for weddings, receptions, destination weddings, family functions, and other events."
  },
  {
    question: "Are airport pickup and drop services available?",
    answer: "Yes, we provide timely airport transfers to and from Mumbai's domestic and international terminals."
  },
  {
    question: "Can I choose a vehicle based on my group size?",
    answer: "Absolutely. We recommend the most suitable vehicle according to the number of passengers, luggage, and travel requirements."
  },
  {
    question: "Are multi-day rental packages available?",
    answer: "Yes, customized multi-day packages are available for vacations, business tours, pilgrimages, and extended road trips."
  },
  {
    question: "How is the rental cost calculated?",
    answer: "The fare depends on the vehicle category, travel distance, rental duration, destination, and selected travel package."
  },
  {
    question: "Is advance reservation recommended?",
    answer: "Yes, advance booking helps ensure vehicle availability, especially during weekends, holidays, festivals, and peak travel periods."
  },
  {
    question: "How can I book a Car Rental in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, preferred vehicle, and itinerary to receive a personalized quotation and quick booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aman Kothari",
    feedback: "Finding the right vehicle for our travel requirements was simple with Shreesha Travels. The entire process was smooth, the car was comfortable, and the journey exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepa Iyer",
    feedback: "Excellent coordination, quality vehicles, and dependable service made our road trip completely stress-free. Every aspect of the journey reflected professionalism and customer-focused service.",
    rating: 5
  }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rental Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/car-rental-mumbai.webp",
  "description":
    "Book Car Rental Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable car rental services. We provide chauffeur-driven Sedan, Ertiga, SUV, Innova, and Innova Crysta cars available 24x7 for local travel, airport transfers, corporate trips, weddings, sightseeing tours, family vacations, and outstation journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/car-rental-mumbai"
  }
};




    return (
        <div>

<Helmet>
  <title>Car Rental Mumbai | Chauffeur Driven Cars | +91 8355835813</title>

  <meta
    name="description"
    content="Book Car Rental Mumbai with Shreesha Travels for reliable chauffeur-driven car rental services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for local, airport, corporate, wedding, sightseeing, and outstation travel with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Car Rental Mumbai, Mumbai Car Rental Service, Car Hire Mumbai, Car Rental with Driver Mumbai, Self Drive Car Rental Mumbai, Luxury Car Rental Mumbai, Outstation Car Rental Mumbai, Airport Car Rental Mumbai, Mumbai Chauffeur Car Rental, Mumbai Car Hire Service, Mumbai Corporate Car Rental, Mumbai Local Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Carrentalmumbai;